// import React, { useState, useEffect } from 'react';
// import { 
//   Autocomplete, 
//   TextField, 
//   Button, 
//   Dialog, 
//   DialogTitle, 
//   DialogContent, 
//   DialogActions,
//   Paper, 
//   Box, 
//   Typography,
//   Container,
//   Fade,
//   Card,
//   CardContent,
//   useTheme,
//   alpha,
//   Avatar,
//   Divider,
//   Stack,
//   Chip
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import {
//   CompareArrows,
//   Search as SearchIcon,
//   AccountTree as AccountTreeIcon,
//   Error as ErrorIcon,
//   CheckCircle as CheckCircleIcon,
//   South as ArrowDownIcon
// } from '@mui/icons-material';
// import axios from 'axios';
// import API_BASE_URL from '../config';
// import Tree from 'react-d3-tree';
// import { useNavigate } from 'react-router-dom';
// import UpgradeModal from '../components/UpgradeModal';
// import useAccess from '../hooks/useAccess';

// // Styled Components
// const StyledPaper = styled(Paper)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
//   borderRadius: theme.spacing(3),
//   padding: theme.spacing(4),
//   position: 'relative',
//   overflow: 'hidden',
//   boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
// }));

// const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: theme.spacing(2),
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       backgroundColor: alpha(theme.palette.primary.main, 0.02),
//     },
//     '&.Mui-focused': {
//       backgroundColor: alpha(theme.palette.primary.main, 0.05),
//       '& fieldset': {
//         borderColor: theme.palette.primary.main,
//         borderWidth: '2px',
//       },
//     },
//   },
// }));

// const RelationshipCard = styled(Card)(({ theme }) => ({
//   background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.secondary.light} 100%)`,
//   color: theme.palette.primary.contrastText,
//   borderRadius: theme.spacing(2),
//   padding: theme.spacing(2),
//   marginTop: theme.spacing(4),
//   boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
// }));

// // NEW: Visual Tree Component for Relationship Connection
// const RelationTree = ({ nodes, relationshipLabel, message }) => {
//   const theme = useTheme();

//   if (!nodes || !Array.isArray(nodes) || nodes.length === 0) return null;

//   // Color palette for nodes — alternating colors
//   const nodeColors = [
//     '#1976d2', // blue — first person
//     '#7b1fa2', // purple — last person  
//     '#0288d1', // light blue — intermediate
//   ];

//   const getNodeColor = (index, total) => {
//     if (index === 0) return nodeColors[0];
//     if (index === total - 1) return nodeColors[1];
//     return nodeColors[2];
//   };

//   return (
//     <Box sx={{ mt: 3 }}>
//       <Paper
//         elevation={0}
//         sx={{
//           p: 3,
//           borderRadius: 3,
//           background: 'rgba(255,255,255,0.95)',
//           border: '1px solid',
//           borderColor: 'divider',
//         }}
//       >
//         {/* Title */}
//         <Typography
//           variant="h6"
//           fontWeight="bold"
//           textAlign="center"
//           sx={{
//             mb: 1,
//             background: 'linear-gradient(45deg, #1976d2, #7b1fa2)',
//             backgroundClip: 'text',
//             WebkitBackgroundClip: 'text',
//             color: 'transparent',
//           }}
//         >
//           Connection Path
//         </Typography>

//         {/* Message */}
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           textAlign="center"
//           sx={{ mb: 3 }}
//         >
//           {message}
//         </Typography>

//         {/* Tree nodes */}
//         <Stack alignItems="center" spacing={0}>
//           {([...nodes]).map((node, index) => (
//             <Box key={node.id || index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              
//               {/* Person node - Vertical Hierarchy */}
//               <Box sx={{ 
//                 display: 'flex', flexDirection: 'column', alignItems: 'center',
//                 mb: index < nodes.length - 1 ? 0 : 2 
//               }}>
//                 <Avatar
//                   sx={{
//                     width: 64,
//                     height: 64,
//                     bgcolor: getNodeColor(index, nodes.length),
//                     fontSize: '1.5rem',
//                     fontWeight: 'bold',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                     border: '3px solid white',
//                   }}
//                 >
//                   {(node.name || '?')[0].toUpperCase()}
//                 </Avatar>
//                 <Typography
//                   variant="body2"
//                   fontWeight="bold"
//                   sx={{ mt: 1, color: getNodeColor(index, nodes.length) }}
//                 >
//                   {node.name || 'Unknown'}
//                 </Typography>
//               </Box>

//               {/* Connector line + label (shown between nodes) */}
//               {index < nodes.length - 1 && (
//                 <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 1 }}>
//                   <Box sx={{ width: 2, height: 16, bgcolor: 'divider' }} />
//                   <Chip
//                     label={node.relationToNext || node.relationship || '↓'}
//                     size="small"
//                     sx={{
//                       bgcolor: (node.relationToNext || node.relationship) ? 'primary.main' : 'grey.200',
//                       color: (node.relationToNext || node.relationship) ? 'white' : 'text.secondary',
//                       fontWeight: 'bold',
//                       fontSize: '0.75rem',
//                       my: 0.5,
//                     }}
//                   />
//                   <Box sx={{ width: 2, height: 16, bgcolor: 'divider' }} />
//                 </Box>
//               )}
//             </Box>
//           ))}
//         </Stack>
//       </Paper>
//     </Box>
//   );
// };

// const UserSearch = () => {
//   const theme = useTheme();
//   const { role, isPremium, loading: accessLoading } = useAccess();
//   const [user1, setUser1] = useState('');
//   const [user2, setUser2] = useState('');
//   const [uid1, setUid1] = useState('');
//   const [uid2, setUid2] = useState('');
//   const [suggestions, setSuggestions] = useState([]);
//   const [isSearchEnabled, setIsSearchEnabled] = useState(false);
//   const [relationship, setRelationship] = useState(""); // Store the relationship sentence
//   const [relationshipPathData, setRelationshipPathData] = useState(null); // Path between the two users
//   const [nodesPath, setNodesPath] = useState([]); // Store intermediate nodes for path tree
//   const [searchError, setSearchError] = useState('');
//   const [showLimitDialog, setShowLimitDialog] = useState(false);
//   const [remainingSearches, setRemainingSearches] = useState(null);
//   const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
//   const navigate = useNavigate();

//   const userRole = role == null ? null : Number(role);

//   // Add this useEffect to fetch user details and search count
//   useEffect(() => {
//     const fetchUserDetails = async () => {
//       try {
//         const userUid = localStorage.getItem('uid');
//         if (!userUid) {
//           navigate('/login');
//           return;
//         }

//         // Fetch remaining searches
//         await fetchRemainingSearches(userUid);
//       } catch (error) {
//         console.error('Failed to fetch user details:', error);
//         if (error.response && error.response.status === 401) {
//           window.location.href = './login';
//         }
//       }
//     };

//     fetchUserDetails();
//   }, []);

//   useEffect(() => {
//     if (accessLoading) return;
//     if (remainingSearches == null) return;
//     if ((userRole == 0 || userRole == 2) && !isPremium && remainingSearches == 0) {
//       setShowLimitDialog(true);
//     }
//   }, [accessLoading, isPremium, remainingSearches, userRole]);

//   // Add this function to fetch remaining searches
//   const fetchRemainingSearches = async (uid) => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/user/remaining-searches`, {
//         params: { uid },
//         withCredentials: true
//       });
//       setRemainingSearches(3 - response.data.searchCount);
//     } catch (error) {
//       console.error('Error fetching remaining searches:', error);
//     }
//   };

//   // Handle search suggestions
//   const handleSearch = async (index, field, value) => {
//     if (value) {
//       try {
//         const response = await axios.get(`${API_BASE_URL}/search`, {
//           params: { [field]: value }
//         });
//         setSuggestions(response.data.length > 0 ? response.data : []);
//       } catch (error) {
//         console.error('Error fetching data:', error);
//         setSuggestions([]);
//       }
//     } else {
//       setSuggestions([]);
//     }
//   };

//   const handleFieldChange = (index, field, value) => {
//     if (index === 0) {
//       setUser1(value);
//       setIsSearchEnabled(value && user2);
//     } else {
//       setUser2(value);
//       setIsSearchEnabled(user1 && value);
//     }
//   };

// const handleSuggestionSelect = (index, selectedOption) => {
//   if (index === 0) {
//     setUid1(selectedOption.uid); // ✅ FIXED
//     setUser1(`${selectedOption.first_name} (UID: ${selectedOption.uid})`);
//   } else {
//     setUid2(selectedOption.uid); // ✅ FIXED
//     setUser2(`${selectedOption.first_name} (UID: ${selectedOption.uid})`);
//   }
// };
//   // Handle search click to find the relationship path
//   const handleSearchClick = async () => {
//     // Frontend validation — ensure both users are selected from dropdown
//     if (!uid1 || !uid2) {
//       setSearchError('Please select both members from the dropdown suggestions.');
//       return;
//     }
//     if (uid1 === uid2) {
//       setSearchError('Please select two different members.');
//       return;
//     }

//     try {
//       const userUid = localStorage.getItem('uid');
//       if (!userUid) {
//         navigate('/login');
//         return;
//       }

//       if ((userRole == 0 || userRole == 2) && !isPremium && remainingSearches == 0) {
//         setShowLimitDialog(true);
//         return;
//       }

//       setSearchError(''); // clear previous messages
//       setRelationship("");
//       setRelationshipPathData(null);
//       setNodesPath([]);
  
//       const response = await axios.post(`${API_BASE_URL}/find-relationship`, {
//         uid1: uid1, 
//         uid2: uid2,
//       });
  
//       if (!response.data.success) {
//         setRelationship("");
//         setRelationshipPathData(null);
//         setNodesPath([]);
//         setSearchError(response.data.message || 'No relation found.');
//       } else if (response.data.success) {
//         // ✅ FIX: Use 'message' sentence from backend, fallback to 'relation' label
//        // const displaySentence = response.data.message || (response.data.relation ? `Relation: ${response.data.relation}` : "Members are connected");
//        const name1 = user1.split("(UID")[0].trim();
// const name2 = user2.split("(UID")[0].trim();

// const relation = response.data.relation;

// // Reverse relation mapping
// const reverseMap = {
//   Father: "Son",
//   Mother: "Son",
//   Son: "Father",
//   Daughter: "Father",
//   Husband: "Wife",
//   Wife: "Husband",
//   Brother: "Brother",
//   Sister: "Sister",
//   Grandfather: "Grandson",
//   Grandmother: "Grandson"
// };

// const reverseRelation = reverseMap[relation] || "";

// // Final sentence
// const mainSentence = `${name1} is ${relation} of ${name2}`;
// const reverseSentence = reverseRelation
//   ? `${name2} is ${reverseRelation} of ${name1}`
//   : "";

// // Combine both
// const finalMessage = reverseSentence
//   ? `${mainSentence} | ${reverseSentence}`
//   : mainSentence;

// setRelationship(finalMessage);
//      //  setRelationship(displaySentence);
//         setRelationshipPathData(response.data.connectionTree || null);
//         setNodesPath(response.data.connectingNodes || []);
//       }
  
//       if ((userRole == 0 || userRole == 2) && !isPremium) {
//         await axios.post(`${API_BASE_URL}/user/increment-search-relationship`, { uid: userUid });
//         await fetchRemainingSearches(userUid);
//       }
//     } catch (error) {
//       const status = error.response?.status;
//       if (status === 400) {
//         setSearchError('Please fill all required fields.');
//       } else if (status === 404) {
//         setSearchError('No relationship found between the selected users.');
//       } else { // Generic error
//         setSearchError('Something went wrong. Please try again.');
//       }
//      // setRelationship(null);
//      setRelationship("");
//       setRelationshipPathData(null);
//     }
//   };

//   return (
//     <Box>
//       <Fade in timeout={1000}>
//         <StyledPaper>
//           <Box sx={{ textAlign: 'center', mb: 6 }}>
//             <Typography 
//               variant="h4" 
//               gutterBottom 
//               sx={{ 
//                 fontWeight: 700,
//                 background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 color: 'transparent',
//               }}
//             >
//               Find Family Relations
//         </Typography>
//             <Typography variant="h6" color="text.secondary">
//               Discover how family members are connected
//         </Typography>
//           </Box>

//           <Box sx={{ 
//             display: 'flex', 
//             flexDirection: { xs: 'column', md: 'row' }, 
//             gap: 3,
//             mb: 4 
//           }}>
//             <StyledAutocomplete
//             freeSolo
//               fullWidth
//             options={suggestions.map((option) => `${option.first_name} (UID: ${option.uid})`)}
//             inputValue={user1}
//             onInputChange={(event, newInputValue) => {
//               handleSearch(0, 'first_name', newInputValue);
//               handleFieldChange(0, 'first_name', newInputValue);
//             }}
//             onChange={(event, newValue) => {
//               const selectedOption = suggestions.find(
//                 (option) => `${option.first_name} (UID: ${option.uid})` === newValue
//               );
//               if (selectedOption) {
//                 handleSuggestionSelect(0, selectedOption);
//               }
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                   label="Select First Person"
//                   placeholder="Start typing a name..."
//                   InputProps={{
//                     ...params.InputProps,
//                     startAdornment: (
//                       <SearchIcon color="action" sx={{ mr: 1 }} />
//                     ),
//                   }}
//               />
//             )}
//           />

//             <Box sx={{ 
//               display: 'flex', 
//               alignItems: 'center', 
//               justifyContent: 'center',
//               px: 2 
//             }}>
//               <CompareArrows 
//                 sx={{ 
//                   transform: { xs: 'rotate(90deg)', md: 'rotate(0deg)' },
//                   color: 'primary.main',
//                   fontSize: 30
//                 }} 
//               />
//             </Box>

//             <StyledAutocomplete
//             freeSolo
//               fullWidth
//             options={suggestions.map((option) => `${option.first_name} (UID: ${option.uid})`)}
//             inputValue={user2}
//             onInputChange={(event, newInputValue) => {
//               handleSearch(1, 'first_name', newInputValue);
//               handleFieldChange(1, 'first_name', newInputValue);
//             }}
//             onChange={(event, newValue) => {
//               const selectedOption = suggestions.find(
//                 (option) => `${option.first_name} (UID: ${option.uid})` === newValue
//               );
//               if (selectedOption) {
//                 handleSuggestionSelect(1, selectedOption);
//               }
//             }}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                   label="Select Second Person"
//                   placeholder="Start typing a name..."
//                   InputProps={{
//                     ...params.InputProps,
//                     startAdornment: (
//                       <SearchIcon color="action" sx={{ mr: 1 }} />
//                     ),
//                   }}
//               />
//             )}
//           />
//           </Box>

//           <Box sx={{ textAlign: 'center', mb: 4 }}>
//             {(userRole == 0 || userRole == 2) && !isPremium && (
//               <Typography 
//                 variant="body2" 
//                 color="textSecondary" 
//                 sx={{ mb: 2, textAlign: 'center' }}
//               >
//                 Upgrade your account to continue searching
//               </Typography>
//             )}
   
          
//           <Button
//             onClick={handleSearchClick}
//             variant="contained"
//             color="primary"
//               disabled={!isSearchEnabled || ((userRole == 0 || userRole == 2) && !isPremium)}
//               startIcon={<AccountTreeIcon />}
//               sx={{
//                 borderRadius: 8,
//                 px: 4,
//                 py: 1,
//                 fontSize: '1.1rem',
//               }}
//             >
//               Find Relation
//           </Button>
//           </Box>

//           {/* Info Message */}
//       {searchError && (
//             <Box sx={{ 
//               textAlign: 'center', 
//               my: 3,
//               p: 2,
//               bgcolor: alpha(theme.palette.error.main, 0.1),
//               borderRadius: 2
//             }}>
//               <ErrorIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
//               <Typography color="error.main" variant="h6">
//                 {searchError}
//               </Typography>
//             </Box>
//           )}

//    {/* ✅ RELATION MESSAGE CARD */}
// {relationship && (
//   <RelationshipCard>
//     <CardContent sx={{ textAlign: 'center' }}>
//       <CheckCircleIcon sx={{ fontSize: 40, mb: 1 }} />

//       <Typography variant="h6" fontWeight="bold">
//         {relationship}
//       </Typography>
//     </CardContent>
//   </RelationshipCard>
// )}
  
//           {/* Visual tree path */}
//           {nodesPath.length > 0 && !relationshipPathData && (
//             <RelationTree 
//               nodes={nodesPath}
//               relationshipLabel={relationship}
//               message={relationship}
//             />
//           )}

//           {/* Tree Visualization */}
//         {relationshipPathData && (
//             <Box sx={{ 
//               height: 600, 
//               mt: 4,
//               border: `1px solid ${theme.palette.divider}`,
//               borderRadius: 4,
//               overflow: 'hidden',
//               bgcolor: 'background.paper',
//               boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//               '& .rd3t-label__title': { fontWeight: 'bold', fontSize: '1rem' },
//               '& .rd3t-label__attributes': { fontSize: '0.8rem' },
//               '& .rd3t-link': { stroke: theme.palette.primary.main, strokeWidth: 2 },
//               '& .rd3t-leaf-node circle, & .rd3t-node circle': { display: 'none' } // Hide default circles to use custom cards
//             }}>
//           <Tree
//             data={relationshipPathData}
//             orientation="vertical" 
//             translate={{ x: 400, y: 50 }}
//             pathFunc="step"
//             zoomable={true}
//             nodeSize={{ x: 300, y: 200 }} // Standard spacing for hierarchy
//             renderCustomNodeElement={(rd3tProps) => (
//               <g>
//                 {/* Main Person Card */}
//                 <foreignObject x="-75" y="-40" width="150" height="80">
//                   <Box sx={{ 
//                     p: 1, 
//                     bgcolor: rd3tProps.nodeDatum.attributes?.gender === 'Female' ? alpha(theme.palette.secondary.light, 0.2) : alpha(theme.palette.primary.light, 0.2),
//                     border: rd3tProps.nodeDatum.attributes?.id === Number(localStorage.getItem('userId')) ? `3px solid ${theme.palette.secondary.main}` : `2px solid ${theme.palette.primary.main}`,
//                     borderRadius: 2,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 1,
//                     boxShadow: 2
//                   }}>
//                     <Avatar src={rd3tProps.nodeDatum.attributes?.imageUrl} sx={{ width: 32, height: 32 }} />
//                     <Box sx={{ textAlign: 'left' }}>
//                       <Typography variant="caption" fontWeight="bold" display="block" noWrap sx={{ width: 90 }}>{rd3tProps.nodeDatum.name}</Typography>
//                       <Typography variant="caption" display="block" color="text.secondary" sx={{ fontSize: '0.6rem' }}>{rd3tProps.nodeDatum.attributes?.relationship}</Typography>
//                     </Box>
//                   </Box>
//                 </foreignObject>

//                 {/* Attached Spouse (If exists) */}
//                 {rd3tProps.nodeDatum.attributes?.spouse && (
//                   <g>
//                     <line x1="75" y1="0" x2="105" y2="0" stroke={theme.palette.divider} strokeWidth="2" strokeDasharray="4" />
//                     <foreignObject x="105" y="-40" width="150" height="80">
//                       <Box sx={{ 
//                         p: 1, 
//                         bgcolor: alpha(theme.palette.background.paper, 0.9),
//                         border: `2px solid ${theme.palette.divider}`,
//                         borderRadius: 2,
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: 1,
//                         height: '100%',
//                         boxShadow: 1
//                       }}>
//                         <Avatar src={rd3tProps.nodeDatum.attributes.spouse.imageUrl} sx={{ width: 32, height: 32 }} />
//                         <Box sx={{ textAlign: 'left' }}>
//                           <Typography variant="caption" fontWeight="bold" display="block" noWrap sx={{ width: 90 }}>{rd3tProps.nodeDatum.attributes.spouse.name}</Typography>
//                           <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.6rem' }}>{rd3tProps.nodeDatum.attributes.spouse.relationship}</Typography>
//                         </Box>
//                       </Box>
//                     </foreignObject>
//                   </g>
//                 )}
//               </g>
//             )}
//           />
//             </Box>
//           )}

//           {/* Upgrade Dialog */}
//           <Dialog 
//             open={showLimitDialog} 
//             onClose={() => setShowLimitDialog(false)}
//             PaperProps={{
//               sx: {
//                 borderRadius: 3,
//                 p: 2
//               }
//             }}
//           >
//             <DialogTitle sx={{ textAlign: 'center' }}>
//               <ErrorIcon sx={{ fontSize: 40, color: theme.palette.warning.main, mb: 1 }} />
//               <Typography variant="h5">Search Limit Reached</Typography>
//             </DialogTitle>
//             <DialogContent>
//               <Typography align="center">
//                 You have used all searches available in the free plan. 
//                 Upgrade your account to unlock unlimited searches and more features.
//               </Typography>
//             </DialogContent>
//             <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
//               <Button 
//                 onClick={() => {
//                   setShowLimitDialog(false);
//                   setUpgradeModalOpen(true);
//                 }}
//                 variant="contained" 
//                 color="primary"
//                 sx={{ borderRadius: 8, px: 4 }}
//               >
//                 Upgrade Now
//               </Button>
//               <Button 
//                 onClick={() => setShowLimitDialog(false)}
//                 variant="outlined"
//                 sx={{ borderRadius: 8, px: 4 }}
//               >
//                 Maybe Later
//               </Button>
//             </DialogActions>
//           </Dialog>

//           <UpgradeModal
//             open={upgradeModalOpen}
//             onClose={() => setUpgradeModalOpen(false)}
//             featureLabel="Find Relation"
//           />
//         </StyledPaper>
//       </Fade>
//     </Box>
//   );
// };

// export default UserSearch;


import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  Box,
  Typography,
  Container,
  Fade,
  Card,
  CardContent,
  useTheme,
  alpha,
  Avatar,
  Divider,
  Stack,
  Chip,
  CircularProgress,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  CompareArrows,
  Search as SearchIcon,
  AccountTree as AccountTreeIcon,
  Error as ErrorIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import axios from 'axios';
import API_BASE_URL, { BASE_URL } from '../config';
import { useNavigate } from 'react-router-dom';
import UpgradeModal from '../components/UpgradeModal';
import useAccess from '../hooks/useAccess';

// ─── Styled Components ───────────────────────────────────────────────────────

const StyledPaper = styled(Paper)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(4),
  position: 'relative',
  overflow: 'hidden',
  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.spacing(2),
    transition: 'all 0.3s ease',
    '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.02) },
    '&.Mui-focused': {
      backgroundColor: alpha(theme.palette.primary.main, 0.05),
      '& fieldset': { borderColor: theme.palette.primary.main, borderWidth: '2px' },
    },
  },
}));

const ResultBanner = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  textAlign: 'center',
  color: '#fff',
  marginBottom: theme.spacing(3),
}));

// ─── Connection Path Tree ─────────────────────────────────────────────────────
// Vertical chain: each person card connected by a labeled arrow.
// person1 (top, blue highlight) → intermediates → person2 (bottom, purple highlight)

const ConnectionPathTree = ({ connectingNodes, highlightIds = [] }) => {
  const theme = useTheme();
  if (!connectingNodes || connectingNodes.length < 1) return null;

  const highlightSet = new Set(highlightIds.map(String));

  // Determine which highlighted node is first vs last in the display order
  const firstHighlightIdx = connectingNodes.findIndex(n => highlightSet.has(String(n.id)));
  const lastHighlightIdx  = [...connectingNodes].reverse().findIndex(n => highlightSet.has(String(n.id)));
  const lastHighlightActualIdx = connectingNodes.length - 1 - lastHighlightIdx;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
      {connectingNodes.map((node, idx) => {
        const isHighlighted = highlightSet.has(String(node.id));
        const isPerson1     = isHighlighted && idx === firstHighlightIdx;
        const isPerson2     = isHighlighted && idx === lastHighlightActualIdx && idx !== firstHighlightIdx;

        const imgSrc = node.imageUrl
          ? node.imageUrl.startsWith('http') ? node.imageUrl : `${BASE_URL}${node.imageUrl}`
          : null;

        const borderColor = isPerson1
          ? theme.palette.primary.main
          : isPerson2
          ? theme.palette.secondary.main
          : isHighlighted
          ? theme.palette.primary.light
          : theme.palette.divider;

        const bgColor = isPerson1
          ? alpha(theme.palette.primary.light, 0.18)
          : isPerson2
          ? alpha(theme.palette.secondary.light, 0.18)
          : theme.palette.background.paper;

        const avatarBg = isPerson1
          ? 'primary.main'
          : isPerson2
          ? 'secondary.main'
          : String(node.gender || '').toLowerCase() === 'female'
          ? 'secondary.light'
          : 'grey.400';

        // The connector chip label: what the PREVIOUS node's relation to THIS node is.
        // API sends relationToNext on each node = "what this node IS to the next node".
        // So for the connector above node[idx], we use connectingNodes[idx-1].relationToNext
        const connectorLabel = idx > 0
          ? (connectingNodes[idx - 1].relationToNext || '')
          : null;

        return (
          <React.Fragment key={`node-${node.id ?? idx}`}>
            {/* ── Connector line + relation label ── */}
            {idx > 0 && (
              <Box sx={{
                display: 'flex', flexDirection: 'column',
                alignItems: 'center', my: 0.5, gap: 0,
              }}>
                <Box sx={{ width: 2, height: 20, background: theme.palette.primary.main, borderRadius: 1 }} />
                {connectorLabel ? (
                  <Chip
                    label={connectorLabel}
                    size="small"
                    sx={{
                      fontSize: '0.68rem', height: 22, fontWeight: 700,
                      bgcolor: alpha(theme.palette.primary.main, 0.13),
                      color: theme.palette.primary.dark,
                      my: 0.25,
                    }}
                  />
                ) : (
                  <Box sx={{ height: 6 }} />
                )}
                <Box sx={{ width: 2, height: 20, background: theme.palette.primary.main, borderRadius: 1 }} />
              </Box>
            )}

            {/* ── Person card ── */}
            <Box sx={{
              display: 'flex', alignItems: 'center', gap: 2,
              px: 2.5, py: 1.5, borderRadius: 3,
              border: `2px solid ${borderColor}`,
              background: bgColor,
              minWidth: 240,
              maxWidth: 320,
              boxShadow: isHighlighted ? 4 : 1,
              transition: 'all 0.2s',
            }}>
              <Avatar src={imgSrc} sx={{ width: 46, height: 46, bgcolor: avatarBg, flexShrink: 0 }}>
                {(node.name || '?').charAt(0).toUpperCase()}
              </Avatar>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="subtitle2" fontWeight={700} noWrap>
                  {node.name}
                </Typography>
                {/* Show the relation label under the name (what this person IS) */}
                {node.relationship && node.relationship !== 'Start' && (
                  <Typography variant="caption" color="text.secondary" display="block">
                    {node.relationship}
                  </Typography>
                )}
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.3 }}>
                  {isPerson1 && (
                    <Chip label="Person 1" size="small" color="primary"
                      sx={{ height: 16, fontSize: '0.58rem' }} />
                  )}
                  {isPerson2 && (
                    <Chip label="Person 2" size="small" color="secondary"
                      sx={{ height: 16, fontSize: '0.58rem' }} />
                  )}
                </Box>
              </Box>
            </Box>
          </React.Fragment>
        );
      })}
    </Box>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────

const UserSearch = () => {
  const theme   = useTheme();
  const navigate = useNavigate();
  const { role, isPremium, loading: accessLoading } = useAccess();

  // Search inputs
  const [user1, setUser1] = useState('');
  const [user2, setUser2] = useState('');
  const [uid1,  setUid1]  = useState('');
  const [uid2,  setUid2]  = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isSearchEnabled, setIsSearchEnabled] = useState(false);

  // Result state
  const [result,      setResult]      = useState(null);   // full API response
  const [searchError, setSearchError] = useState('');
  const [loading,     setLoading]     = useState(false);

  // Premium / search limits
  const [showLimitDialog,   setShowLimitDialog]   = useState(false);
  const [remainingSearches, setRemainingSearches] = useState(null);
  const [upgradeModalOpen,  setUpgradeModalOpen]  = useState(false);

  const userRole = role == null ? null : Number(role);

  // ── Fetch user details on mount ───────────────────────────────────────────

  useEffect(() => {
    const init = async () => {
      try {
        const userUid = localStorage.getItem('uid');
        if (!userUid) { navigate('/login'); return; }
        await fetchRemainingSearches(userUid);
      } catch (err) {
        console.error('Init error:', err);
        if (err.response?.status === 401) window.location.href = './login';
      }
    };
    init();
  }, []);

  useEffect(() => {
    if (accessLoading || remainingSearches == null) return;
    if ((userRole === 0 || userRole === 2) && !isPremium && remainingSearches === 0) {
      setShowLimitDialog(true);
    }
  }, [accessLoading, isPremium, remainingSearches, userRole]);

  const fetchRemainingSearches = async (uid) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/user/remaining-searches`, {
        params: { uid },
        withCredentials: true,
      });
      setRemainingSearches(3 - res.data.searchCount);
    } catch (err) {
      console.error('Error fetching remaining searches:', err);
    }
  };

  // ── Search suggestions ────────────────────────────────────────────────────

  const handleSearch = async (field, value) => {
    if (!value) { setSuggestions([]); return; }
    try {
      const res = await axios.get(`${API_BASE_URL}/search`, { params: { [field]: value } });
      setSuggestions(res.data?.length > 0 ? res.data : []);
    } catch {
      setSuggestions([]);
    }
  };

  const handleFieldChange = (index, value) => {
    if (index === 0) { setUser1(value); setIsSearchEnabled(!!(value && user2)); }
    else             { setUser2(value); setIsSearchEnabled(!!(user1 && value)); }
  };

  const handleSuggestionSelect = (index, opt) => {
    if (index === 0) {
      setUid1(opt.uid);
      setUser1(`${opt.first_name} (UID: ${opt.uid})`);
    } else {
      setUid2(opt.uid);
      setUser2(`${opt.first_name} (UID: ${opt.uid})`);
    }
  };

  // ── Find relation ──────────────────────────────────────────────────────────

  const handleSearchClick = async () => {
    if (!uid1 || !uid2) {
      setSearchError('Please select both members from the dropdown suggestions.');
      return;
    }
    if (uid1 === uid2) {
      setSearchError('Please select two different members.');
      return;
    }
    if ((userRole === 0 || userRole === 2) && !isPremium && remainingSearches === 0) {
      setShowLimitDialog(true);
      return;
    }

    try {
      setLoading(true);
      setSearchError('');
      setResult(null);

      const userUid = localStorage.getItem('uid');
      if (!userUid) { navigate('/login'); return; }

      const res = await axios.post(
        `${API_BASE_URL}/find-relationship`,
        { uid1, uid2 },
        { withCredentials: true }
      );

      if (!res.data.success) {
        setSearchError(res.data.message || 'No relation found.');
      } else {
        setResult(res.data);
      }

      // Decrement search count for free users
      if ((userRole === 0 || userRole === 2) && !isPremium) {
        await axios.post(`${API_BASE_URL}/user/increment-search-relationship`, { uid: userUid });
        await fetchRemainingSearches(userUid);
      }
    } catch (err) {
      const status = err.response?.status;
      if (status === 400)      setSearchError('Please fill all required fields.');
      else if (status === 404) setSearchError('No relationship found between the selected users.');
      else                     setSearchError('Something went wrong. Please try again.');
      setResult(null);
    } finally {
      setLoading(false);
    }
  };

  // ── Build path nodes from API response ────────────────────────────────────
  // connectingNodes from API: [{ id, name, gender, imageUrl, relationToNext, relationship }, ...]
  // Already ordered senior → junior by the backend controller.

  const buildPathNodes = (res) => {
    if (!res?.connectingNodes?.length) return [];
    return res.connectingNodes.map((n, idx) => ({
      id:            n.id,
      name:          n.name          || 'Unknown',
      gender:        n.gender        || '',
      imageUrl:      n.imageUrl      || n.image_url || null,
      relationToNext: n.relationToNext || null,
      relationship:  n.relationship  || (idx === 0 ? 'Start' : ''),
    }));
  };

  const pathNodes    = buildPathNodes(result);
  // highlightIds = the two originally searched users (always person1 and person2)
  const highlightIds = result?.highlightIds || [];

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <Box>
      <Fade in timeout={1000}>
        <StyledPaper>

          {/* ── Header ── */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography
              variant="h4" gutterBottom
              sx={{
                fontWeight: 700,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent',
              }}
            >
              Find Family Relations
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Discover how family members are connected
            </Typography>
          </Box>

          {/* ── Search inputs ── */}
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, mb: 4 }}>
            <StyledAutocomplete
              freeSolo fullWidth
              options={suggestions.map(o => `${o.first_name} (UID: ${o.uid})`)}
              inputValue={user1}
              onInputChange={(_, v) => {
                handleSearch('first_name', v);
                handleFieldChange(0, v);
              }}
              onChange={(_, v) => {
                const opt = suggestions.find(o => `${o.first_name} (UID: ${o.uid})` === v);
                if (opt) handleSuggestionSelect(0, opt);
              }}
              renderInput={(params) => (
                <TextField
                  {...params} label="Select First Person" placeholder="Start typing a name…"
                  InputProps={{ ...params.InputProps, startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} /> }}
                />
              )}
            />

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', px: 2 }}>
              <CompareArrows
                sx={{
                  transform: { xs: 'rotate(90deg)', md: 'rotate(0deg)' },
                  color: 'primary.main', fontSize: 30,
                }}
              />
            </Box>

            <StyledAutocomplete
              freeSolo fullWidth
              options={suggestions.map(o => `${o.first_name} (UID: ${o.uid})`)}
              inputValue={user2}
              onInputChange={(_, v) => {
                handleSearch('first_name', v);
                handleFieldChange(1, v);
              }}
              onChange={(_, v) => {
                const opt = suggestions.find(o => `${o.first_name} (UID: ${o.uid})` === v);
                if (opt) handleSuggestionSelect(1, opt);
              }}
              renderInput={(params) => (
                <TextField
                  {...params} label="Select Second Person" placeholder="Start typing a name…"
                  InputProps={{ ...params.InputProps, startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} /> }}
                />
              )}
            />
          </Box>

          {/* ── Find button ── */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            {(userRole === 0 || userRole === 2) && !isPremium && (
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                Upgrade your account to continue searching
              </Typography>
            )}
            <Button
              onClick={handleSearchClick}
              variant="contained" color="primary"
              disabled={!isSearchEnabled || loading || ((userRole === 0 || userRole === 2) && !isPremium)}
              startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <AccountTreeIcon />}
              sx={{ borderRadius: 8, px: 4, py: 1, fontSize: '1.1rem' }}
            >
              {loading ? 'Finding…' : 'Find Relation'}
            </Button>
          </Box>

          {/* ── Error ── */}
          {searchError && (
            <Box sx={{
              textAlign: 'center', my: 3, p: 2,
              bgcolor: alpha(theme.palette.error.main, 0.1), borderRadius: 2,
            }}>
              <ErrorIcon color="error" sx={{ fontSize: 40, mb: 1 }} />
              <Typography color="error.main" variant="h6">{searchError}</Typography>
            </Box>
          )}

          {/* ── Result ── */}
          {result && (
            <>
              {/* Banner — uses the correct message from backend */}
              <ResultBanner>
                <CheckCircleIcon sx={{ fontSize: 38, mb: 0.5 }} />
                <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
                  {result.message}
                </Typography>
              </ResultBanner>

              {/* Connection path tree */}
              {pathNodes.length >= 2 && (
                <Paper sx={{
                  p: 3, borderRadius: 3, mt: 1,
                  background: 'rgba(255,255,255,0.95)',
                  border: `1px solid ${theme.palette.divider}`,
                }}>
                  {/* Sub-title */}
                  <Typography
                    variant="h6" fontWeight="bold" textAlign="center"
                    sx={{
                      mb: 0.5,
                      background: 'linear-gradient(45deg, #1976d2, #7b1fa2)',
                      backgroundClip: 'text', WebkitBackgroundClip: 'text', color: 'transparent',
                    }}
                  >
                    Connection Path
                  </Typography>
                  <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 2 }}>
                    {result.message}
                  </Typography>

                  <ConnectionPathTree
                    connectingNodes={pathNodes}
                    highlightIds={highlightIds}
                  />
                </Paper>
              )}
            </>
          )}

          {/* ── Search limit dialog ── */}
          <Dialog
            open={showLimitDialog}
            onClose={() => setShowLimitDialog(false)}
            PaperProps={{ sx: { borderRadius: 3, p: 2 } }}
          >
            <DialogTitle sx={{ textAlign: 'center' }}>
              <ErrorIcon sx={{ fontSize: 40, color: theme.palette.warning.main, mb: 1 }} />
              <Typography variant="h5">Search Limit Reached</Typography>
            </DialogTitle>
            <DialogContent>
              <Typography align="center">
                You have used all searches available in the free plan.
                Upgrade your account to unlock unlimited searches and more features.
              </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
              <Button
                onClick={() => { setShowLimitDialog(false); setUpgradeModalOpen(true); }}
                variant="contained" color="primary"
                sx={{ borderRadius: 8, px: 4 }}
              >
                Upgrade Now
              </Button>
              <Button
                onClick={() => setShowLimitDialog(false)}
                variant="outlined"
                sx={{ borderRadius: 8, px: 4 }}
              >
                Maybe Later
              </Button>
            </DialogActions>
          </Dialog>

          <UpgradeModal
            open={upgradeModalOpen}
            onClose={() => setUpgradeModalOpen(false)}
            featureLabel="Find Relation"
          />

        </StyledPaper>
      </Fade>
    </Box>
  );
};

export default UserSearch;